import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {EditBreadcrumb, IState} from "./Data";
import { EmailTemplateModel } from '../../model';
import { CreateLayout } from '../../layout/CreateLayout';
import { EmailTemplateForm } from './form';
import { EmailTemplateService } from '../../services/EmailTemplateService';

export class EditEmailTemplates extends React.Component<RouteComponentProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            id: props.match.params.id,
            template: {} as EmailTemplateModel
        }
    }

    init = async () => {
        const template: EmailTemplateModel = await EmailTemplateService.get(this.state.id);
        this.setState({
            template
        })
    }
    
    componentDidMount() {
        this.init();
    }
    render() {
        return (
            <CreateLayout breadcrumb={EditBreadcrumb} title={'Update email template'}>
                <EmailTemplateForm {...this.state}/>
            </CreateLayout>
        )
    }
}
